import { useCallback, useEffect } from 'react';

import { setEnemyData } from './useEnemyData';
import { setOwnData } from './useOwnData';
import usePrevious from './usePrevious';
import { useIntelState } from '../context/IntelState';

export const useDataRefresher = (isViewingEnemy: boolean) => {
  const { intelState, intelDispatch } = useIntelState();
  const previousEnemy = usePrevious(intelState.enemyKd);
  const previousServer = usePrevious(intelState.server);
  const refreshData = useCallback(
    (forceRefresh: boolean) => {
      const serverChanged = previousServer !== intelState.server;
      const shouldRefreshEnemy =
        !intelState.enemyData ||
        serverChanged ||
        previousEnemy !== intelState.enemyKd;
      if (isViewingEnemy) {
        if (forceRefresh || (intelState.enemyKd && shouldRefreshEnemy)) {
          setEnemyData(intelState.server, intelState.enemyKd, intelDispatch);
        }
      } else if (forceRefresh || !intelState.ownData || serverChanged) {
        setOwnData(intelState.server, intelDispatch);
      }
    },
    [
      intelDispatch,
      intelState.enemyData,
      intelState.enemyKd,
      intelState.ownData,
      intelState.server,
      isViewingEnemy,
      previousEnemy,
      previousServer,
    ]
  );

  useEffect(() => {
    refreshData(false);
    const interval = setInterval(() => {
      refreshData(true);
    }, 30000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [refreshData]);
};
